import React from "react";
import { Link } from "react-router-dom";
import blogIndex from "./blogs/blogData.json"; // rename import to force HMR reloads sometimes

const BlogList = () => {
  // Sort newest first (assumes YYYY-MM-DD)
  const posts = [...blogIndex].sort((a, b) => (b.date || "").localeCompare(a.date || ""));

  // quick debug to verify both posts are loaded
  console.log("Blog posts loaded:", posts.map(p => ({ slug: p.slug, date: p.date })));

  return (
    <div className="max-w-6xl mx-auto px-5 py-10">
      <h1 className="text-4xl font-bold mb-8 text-center">MyBOQ Blog</h1>

      {posts.length === 0 ? (
        <div className="text-center text-gray-500">No posts yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {posts.map((blog) => (
            <article
              key={blog.slug}
              className="border rounded-2xl shadow hover:shadow-lg transition bg-white overflow-hidden"
            >
              <img
                src={blog.thumbnail || "/images/blog/placeholder.jpg"}
                alt={blog.title}
                loading="lazy"
                onError={(e) => { e.currentTarget.src = "/images/blog/placeholder.jpg"; }}
                className="w-full h-56 object-cover"
              />

              <div className="p-5">
                <div className="text-xs text-gray-500">
                  {blog.date} • {blog.reading_time || "5–7 min"}
                </div>
                <h2 className="text-xl font-semibold mt-1">{blog.title}</h2>
                <p className="text-gray-600 mt-2">{blog.excerpt}</p>

                <Link
                  to={`/blog/${blog.slug}`}
                  className="text-orange-600 mt-4 inline-block hover:text-orange-700 font-semibold"
                >
                  Read More →
                </Link>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogList;
